import 'twin.macro';
import 'styled-components/macro';

import { UserProfile as UserProfileType } from 'types/graphql';

export interface UserProfileProps extends React.HTMLProps<HTMLDivElement> {
  profile: Pick<UserProfileType, 'avatar' | 'display_name' | 'slug'>;
}

export const UserProfile = ({ profile: { avatar, display_name, slug }, ...props }: UserProfileProps) => (
  <div tw="flex flex-col items-center text-center" {...props}>
    {avatar && <img alt="Profile" src={avatar} tw="rounded-full mb-3 h-20 w-20" />}
    <div tw="display-4 break-words w-full">{display_name}</div>
    {slug && <div tw="text-base text-gray-50">@{slug}</div>}
  </div>
);
